import React from 'react'

export default function() {
  return (
    <>
    <div className='navbar'>
    <h3><i className="fa-brands fa-github me-3 fx-2x"></i>Github finder</h3>
    </div>
  
    </>
  )
}
